import React from "react";
import _ from "lodash";
import { ContactInfoStyles } from "./styles.module";
import { userFriendlyPhone } from "../../../helpers/PhoneHelper";
import { customerUrl, techUrl } from "../../../helpers/Common";
import { ContactTypes } from "../../constants";

interface ICustomerProps {
  activeContact: any;
}

export class ContactInfo extends React.Component<ICustomerProps> {
  state = {};

  constructor(props: ICustomerProps) {
    super(props);
  }

  render() {
    const originalContact = (this.props.activeContact || {}).original || {};
    const contactUrl =
      ContactTypes.CUSTOMER === originalContact.type
        ? customerUrl(originalContact.system_item_id)
        : techUrl(originalContact.system_item_id);

    return (
      <ContactInfoStyles>
        <div className="customer-info-panel-data">
          <div className="customer-info-panel-data__label typo typo-label-14">
            Name
          </div>
          <div className="customer-info-panel-data__user-name typo typo-text-14">
            <a href={contactUrl} target="_blank">
              {originalContact.first_name} {originalContact.last_name}
            </a>
          </div>

          <div className="customer-info-panel-data__label typo typo-label-14">
            Phone
          </div>
          <div className="customer-info-panel-data__prop typo typo-text-14">
            {originalContact.phone ? (
              <a className="customer-info-panel-data__phone-link">
                {userFriendlyPhone(originalContact.phone)}
              </a>
            ) : (
              "none"
            )}
          </div>

          <div>
            <div className="customer-info-panel-data__label typo typo-label-14">
              Address
            </div>
            <div className="customer-info-panel-data__prop typo typo-text-14">
              {originalContact.address ? originalContact.address : "none"}
            </div>
          </div>
        </div>
      </ContactInfoStyles>
    );
  }
}
